/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// document.addEventListener("DOMContentLoaded", function () {
 

//   const characterLimit = 350; 
//   const contentClose = document.querySelector(".editor-letter__content-close");
//   const firstParagraph = contentClose.querySelector("p:first-child");

//   let truncated = true;
//   let originalText = ""; 

//   if (firstParagraph) {
//     originalText = firstParagraph.textContent; 
//     if (originalText.length > characterLimit) {
//       let truncatedText = originalText.substring(0, characterLimit) + "...";
//       firstParagraph.textContent = truncatedText;
//     }
//   }

//   const readMore = document.querySelector(".editor-letter__read-more");
//   if (readMore) {
//     readMore.addEventListener("click", function (event) {
//       event.preventDefault();

  

//       if (truncated) {
//         firstParagraph.textContent = originalText; 
//         contentClose.classList.remove("editor-letter__content-close");
//         contentClose.classList.add("editor-letter__content-open");
//         readMore.textContent = "Read Less";
//       } else {
//         let truncatedText = originalText.substring(0, characterLimit) + "...";
//         firstParagraph.textContent = truncatedText; 
//         contentClose.classList.remove("editor-letter__content-open");
//         contentClose.classList.add("editor-letter__content-close");
//         readMore.textContent = "Read More";
//       }

//       truncated = !truncated; 
//     });
//   }
// });
document.addEventListener("DOMContentLoaded", function () {

  const characterLimit = 350; // Set your character limit
  const contentClose = document.querySelector(".editor-letter__content-close");

  if (!contentClose) {
    console.error("contentClose element not found");
    return;
  }

  let truncated = true;
  let originalHTML = contentClose.innerHTML; // Store the original full HTML content
  let originalText = contentClose.textContent; // Store text version for length checking

  // Function to truncate HTML content while preserving tags
  function truncateHTML(html, limit) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const textContent = tempDiv.textContent || tempDiv.innerText;
    
    if (textContent.length <= limit) {
      return html;
    }
    
    // If we need to truncate, get the text version and truncate it
    const truncatedText = textContent.substring(0, limit) + "...";
    
    // Try to preserve some HTML structure by finding a good break point
    let currentLength = 0;
    let result = '';
    const walker = document.createTreeWalker(
      tempDiv,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    let node;
    while (node = walker.nextNode()) {
      const nodeText = node.textContent;
      if (currentLength + nodeText.length <= limit) {
        currentLength += nodeText.length;
      } else {
        const remainingChars = limit - currentLength;
        if (remainingChars > 0) {
          node.textContent = nodeText.substring(0, remainingChars) + "...";
        } else {
          node.textContent = "...";
        }
        break;
      }
    }
    
    return tempDiv.innerHTML;
  }

  // Initial truncation if needed
  if (originalText.length > characterLimit) {
    contentClose.innerHTML = truncateHTML(originalHTML, characterLimit);
  }

  const readMore = document.querySelector(".editor-letter__read-more");

  if (!readMore) {
    return;
  }

  readMore.addEventListener("click", function (event) {
    event.preventDefault();

    if (truncated) {
      contentClose.innerHTML = originalHTML; // Show full HTML content
      contentClose.classList.remove("editor-letter__content-close");
      contentClose.classList.add("editor-letter__content-open");
      readMore.textContent = "Read Less";
    } else {
      contentClose.innerHTML = truncateHTML(originalHTML, characterLimit); // Show truncated HTML content
      contentClose.classList.remove("editor-letter__content-open");
      contentClose.classList.add("editor-letter__content-close");
      readMore.textContent = "Read More";
    }

    truncated = !truncated; // Toggle the truncated state
  });
});